import React from "react";
import { ArrowLeft, Button } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "./CustomCampaignShowContainer";

const headerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  padding: "4px 16px",
};

const CustomCampaignTemplateHeader = () => {
  const {
    customCampaign,
  } = useCustomCampaignShowContext();

  return (
    <div style={headerStyle}>
      <Button
        as="a"
        variant="link-gray"
        icon={ArrowLeft}
        href={`/admin/custom_campaigns_templates/${customCampaign.id}`}
      >
        Back
      </Button>
    </div>
  );
};

export default CustomCampaignTemplateHeader;
